import React from 'react';
import { useTranslation } from 'react-i18next';
import Image from '../../Image';

import styles from './styles.module.scss';

const ChoiceAnswer = ({ question, item, setSelectedAnswer }) => {
  const { t } = useTranslation();

  return <button
    onClick={() => setSelectedAnswer(question, item)}
    className={styles.answer + ' ' + (question.answer ? question.answer?.key === item.key ? styles.selected : styles.unselected : '')}
  >
    <span className={styles.icon_holder}>
      <Image src={'images_iax/icon-' + item.key} type={'svg'} className={styles.icon} />
    </span>
    <span className={styles.text}>
      {t(item.text)}
    </span>
  </button>;
}

export default ChoiceAnswer;
